import { render, staticRenderFns } from "./FamilyServicePlanTab.vue?vue&type=template&id=2debe368&scoped=true&lang=pug"
import script from "./FamilyServicePlanTab.vue?vue&type=script&lang=ts"
export * from "./FamilyServicePlanTab.vue?vue&type=script&lang=ts"
import style0 from "./FamilyServicePlanTab.vue?vue&type=style&index=0&id=2debe368&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2debe368",
  null
  
)

export default component.exports